import React from "react";
import "./dance.css";

function Dance() {
  return (
    <>
      <div className="content">
        <div className="dance-1">
          <h3>Dance forms of India </h3>
          <p>
            {" "}
            Indian classical dance or 'Shastriya Devesh' is an umbrella term for
            back to Various performance arts rooted in religious Hindu musical
            theatre styles, whose theory and practice can be traced to the
            Sanskrit text Natya Shastra. The number of recognised classical
            dances range from eight to more, depending on the source and
            scholar. The Sangeet Natak Academy recognizes eight – Bharatanatyam,
            Kathak, Kuchipudi, Odissi, Kathakali, Sattriya, Manipuri and
            Mohiniyattam. Scholars such as Drid Williams add Chhau, Yakshagana
            and Bhagavata Mela to the list. Additionally, the Indian Ministry of
            Culture includes Chhau in its classical list. These dances are
            traditionally regional, all of them include music and recitation in
            local language or Sanskrit, and they represent a unity of core ideas
            in a diversity of styles, costumes and expression.
          </p>
        </div>
        <div className="dance-2">
        <h1> Diversed states dance forms </h1>
       
        <div className="cardblock-3">
            <div className="card_category_3">
              <img src="https://www.holidify.com/images/cmsuploads/compressed/3531225584_d8f9ce5fd5_b_20170926204243.jpg" />
              <h4> Bharatnatyam, Tamilnadu</h4>
            </div>
            <div className="card_category_3">
              <img src="https://www.holidify.com/images/cmsuploads/compressed/33405125866_02c58f6e8a_b_20170926204513.jpg" />
              <h4> Kathak, Uttar Pradesh</h4>
            </div>
            <div className="card_category_3">
              <img src="https://www.holidify.com/images/cmsuploads/compressed/449px-Kathakalidancer_20170926204612.jpg" />
              <h4> Kathakali, Kerela</h4>
            </div>
            <div className="card_category_3">
              <img src="https://www.holidify.com/images/cmsuploads/compressed/4048039772_4a3629ce62_o_20170927125955.jpg" />
              <h4>  Kuchipudi, Andhra Pradesh</h4>
            </div>
            <div className="card_category_3">
              <img src="https://www.holidify.com/images/cmsuploads/compressed/Garba_20180310125915.jpg" />
              <h4> Garba, Gujarat</h4>
            </div>
            <div className="card_category_3">
              <img src="https://www.holidify.com/images/cmsuploads/compressed/4900987611_68e8e1eed4_b_20170927130314.jpg" />
              <h4> Ghoomar, Rajasthan</h4>
            </div>
            <div className="card_category_3">
              <img src="https://www.holidify.com/images/cmsuploads/compressed/8451130049_7b1c16fd8c_b_20170927130153.jpg" />
              <h4>  Bhangra/Gidda, Punjab</h4>
            </div>
            <div className="card_category_3">
              <img src="https://www.holidify.com/images/cmsuploads/compressed/Lavani_20180314221552.JPG" />
              <h4>  Lavani, Maharashtra</h4>
            </div>
            <div className="card_category_3">
              <img src="https://www.holidify.com/images/cmsuploads/compressed/Bihu_of_Assam_20180314220215.jpg" />
              <h4>  Bihu, Assam </h4>
            </div>
            <div className="card_category_3">
              <img src="            https://www.holidify.com/images/cmsuploads/compressed/Rauff_20180310130603.jpg" />
              <h4>  Rouf, Kashmir </h4>
            </div>
            <div className="card_category_3">
              <img src="https://www.holidify.com/images/cmsuploads/compressed/5906208752_6d6dd71bb3_b_20170927130058.jpg" />
              <h4>  Odissi, Odisha </h4>
            </div>
            <div className="card_category_3">
              <img src="https://www.holidify.com/images/cmsuploads/compressed/486352442_28c34cbf1b_b_20170926204726.jpg" />
              <h4>  Manipuri, Manipur</h4>
            </div>
            </div>
            </div>
      </div>
    </>
  );
}

export default Dance;
